<section class="gap-48 md-gap-16 flex">
  <section class="flex-col">
    <h1 class="heading-1 mb-24 md-mb-12">Your next service isn't due yet</h1>

    <section class="flex-col gap-16 md-gap-12 mb-32 md-mb-24">
      <section class="flex-col gap-4 md-gap-8">
        <p class="body large">It looks like your boiler's already had its service for this year.</p>
        <p class="body large">Your plan includes one service every 12 months.</p>
      </section>

      <section class="flex-col gap-4 md-gap-8">
        <p class="body large">If you have any questions, just give the service provider a call on:</p>
        <app-telephone-link phoneNumber="0344 335 6556" [largeFont]="true" />
      </section>

      <section class="flex-col gap-4 md-gap-8">
        <p class="hint">
          Calls cost the basic rate per minute plus your phone company's access charge. From a mobile, they can cost
          much more. Lines are open 8am-8pm, Monday-Friday and 8.30am-2pm, Saturday-Sunday.
        </p>
      </section>
    </section>

    <app-button
      dataLabel="service-not-due-repair-page-link"
      [buttonOptions]="{
        isLink: true,
        url: vm.repairsPageUrl,
      }"
      class="mb-32 md-mb-24"
    >
      <i class="fa-light fa-arrow-left mr-8"></i>

      Back to repairs page
    </app-button>

    <p class="hint">Error code: {{ vm.errorCode }}</p>
  </section>

  <section>
    <img src="/assets/images/error-icon.png" alt="Error page alert icon" />
  </section>
</section>
